import { B4Regular, px2rem } from '@moim/common';
import { Link } from '../../components/link.mjs';
import styled from 'styled-components';

var Wrapper = styled(Link).withConfig({
  displayName: "Wrapper",
  componentId: "sc-lszz4d-0"
})(["width:100%;display:flex;align-items:center;background-color:", ";"], function (props) {
  return props.theme.colorV2.colorSet.white1000;
});
var Title = styled.div.withConfig({
  displayName: "Title",
  componentId: "sc-lszz4d-1"
})(["width:100%;flex:1;min-width:0;"]);
var Extra = styled(B4Regular).withConfig({
  displayName: "Extra",
  componentId: "sc-lszz4d-2"
})(["color:", ";margin-left:", ";"], function (props) {
  return props.theme.colorV2.colorSet.grey300;
}, px2rem(8));
var IconWrapper = styled.div.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-lszz4d-3"
})(["width:", ";height:", ";"], px2rem(18), px2rem(18));

export { Extra, IconWrapper, Title, Wrapper };
